import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AltpaymentModalComponent } from './altpayment-modal.component';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { DisplayCurrencyModule } from '../display-currency/display-currency.module';
import { NodataModule } from 'src/app/nodata/nodata.module';
import { CustomInputGroupModule } from 'src/app/custom-input-group/custom-input-group.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SkeletonLoaderModule } from 'src/app/skeleton-loader/skeleton-loader.module';



@NgModule({
  declarations: [
    AltpaymentModalComponent
  ],
  imports: [
    CommonModule, PipesModule, DisplayCurrencyModule, NodataModule, CustomInputGroupModule, FormsModule, ReactiveFormsModule, SkeletonLoaderModule
  ], exports: [
    AltpaymentModalComponent
  ]
})
export class AltpaymentModalModule { }
